export default __webpack_public_path__ + "static/media/centrabout.f903eb5e.jpg";